import { render, staticRenderFns } from "./NoItemsDashboard.vue?vue&type=template&id=050926e2&scoped=true"
import script from "./NoItemsDashboard.vue?vue&type=script&lang=js"
export * from "./NoItemsDashboard.vue?vue&type=script&lang=js"
import style0 from "./NoItemsDashboard.vue?vue&type=style&index=0&id=050926e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050926e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('050926e2')) {
      api.createRecord('050926e2', component.options)
    } else {
      api.reload('050926e2', component.options)
    }
    module.hot.accept("./NoItemsDashboard.vue?vue&type=template&id=050926e2&scoped=true", function () {
      api.rerender('050926e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NoItemsDashboard.vue"
export default component.exports